// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGK8B10v_4Et9tRTb7NH {
    position: relative;

    flex: 1 0 45%;
    min-width: 400px;
    max-width: 600px;

    border-radius: 5px;
    background-color: white;
    overflow: hidden;
}

.i1jlSb6W4uiEdLT4Ja7j.CGK8B10v_4Et9tRTb7NH {
    background: #e2e2e2;
    color: transparent;
    position: relative;
    overflow: hidden;
}

.L6O9uTnCU2pcwnCEEuI1 {
    width: 100%;
    height: 100px;
    object-fit: cover;
}

.i1jlSb6W4uiEdLT4Ja7j .L6O9uTnCU2pcwnCEEuI1 {
    background: #ececec;
    color: transparent;
    position: relative;
    overflow: hidden;
}


.o7Dx6vJsMFlKKdsseF20 {
    position: absolute;
    top: 50px;

    width: 100%;

    padding: 16px;
    box-sizing: border-box;
}

.o7Dx6vJsMFlKKdsseF20, .ZlrMhFVq_sWIkeJJrMHQ {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
}

.i1jlSb6W4uiEdLT4Ja7j .VxNBIu60Z5waILMYO2VH,
.i1jlSb6W4uiEdLT4Ja7j .vK_4c5qrkf6pqhjgivoi,
.i1jlSb6W4uiEdLT4Ja7j .umr7sVjAj7yU1HDP6RHb {
    width: 150px;
    height: 18px;
    background: #d3d3d3;
    color: transparent;
    position: relative;
    overflow: hidden;
    margin-bottom: 4px;
    margin-left: 4px;
}

.i1jlSb6W4uiEdLT4Ja7j .umr7sVjAj7yU1HDP6RHb {
    margin-top: 16px;
}

.i1jlSb6W4uiEdLT4Ja7j .sCQwJ4cb_8pY0EIFB35p {
    background: #d3d3d3;
    border: none;
    color: transparent;
    position: relative;
    overflow: hidden;
}

.i1jlSb6W4uiEdLT4Ja7j .VxNBIu60Z5waILMYO2VH::before,
.i1jlSb6W4uiEdLT4Ja7j .vK_4c5qrkf6pqhjgivoi::before,
.i1jlSb6W4uiEdLT4Ja7j .sCQwJ4cb_8pY0EIFB35p::before,
.i1jlSb6W4uiEdLT4Ja7j .umr7sVjAj7yU1HDP6RHb::before {
    content: "";
    position: absolute;
    left: -50%;
    top: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(to right, #d3d3d3 25%, #bebebe 50%, #d3d3d3 100%);
    animation-name: yavhYd9fgoIDUE1Q5PkP;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    filter: blur(5px);
}

.sCQwJ4cb_8pY0EIFB35p {
    width: 86px;
    height: 86px;
    border-radius: 86px;
    border: 4px solid white;
    object-fit: cover;
    background-color: white;
}

.sCQwJ4cb_8pY0EIFB35p.aZy_s_t9E4GBr3FDi7q_ {
    background: rgb(137,154,255);
    background: linear-gradient(90deg, rgba(137,154,255,1) 0%, rgba(79,103,243,1) 35%, rgba(36,56,173,1) 100%);

    display: flex;
    justify-content: center;
    align-items: center;
}

.sCQwJ4cb_8pY0EIFB35p.aZy_s_t9E4GBr3FDi7q_ span {
    font-family: Raleway, sans-serif;
    font-size: 48px;
    font-weight: 700;
    color: white;
}

.NBHbpi45n1Nwwcy6ZEfV {
    margin-top: 40px;
    padding: 16px;
    box-sizing: border-box;

    display: flex;
    justify-content: space-evenly;
}

.VxNBIu60Z5waILMYO2VH {
    margin: 0;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;
}

.vK_4c5qrkf6pqhjgivoi {
    margin: 0;

    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 14px;
}

.RfHayD1QUXv4tjglbBgc p {
    text-align: center;
}

.umr7sVjAj7yU1HDP6RHb {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 0;
}

.Xs4zFt2My04xAyPe38jc {
    margin-top: 0;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

@keyframes yavhYd9fgoIDUE1Q5PkP {
    from {
        left: -50%;
    }
    to {
        left: 100%;
    }
}

@media screen and (max-width: 425px) {
    .CGK8B10v_4Et9tRTb7NH {
        min-width: unset;
        flex: unset;
        width: 100%;
    }

    .o7Dx6vJsMFlKKdsseF20 {
        position: unset;
        padding: 4px;
        flex-wrap: wrap;
    }

    .ZlrMhFVq_sWIkeJJrMHQ {
        align-items: center;
    }

    .NBHbpi45n1Nwwcy6ZEfV {
        padding: 8px;
        margin-top: 0;
        flex-wrap: wrap;
    }

    .umr7sVjAj7yU1HDP6RHb {
        margin: 0;
    }

    .jDzODhFDdOHqYR1Uw13g {
        margin: auto;
        height: 32px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardOpportunity/DashboardOpportunityCard/DashboardOpportunityCard.module.css"],"names":[],"mappings":"AAGA;IACI,kBAAkB;;IAElB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;;IAEhB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;;IAET,WAAW;;IAEX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;;;IAGI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;;;IAII,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,WAAW;IACX,6EAA6E;IAC7E,oCAAkC;IAClC,sBAAsB;IACtB,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,0GAA0G;;IAE1G,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;;IAEtB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;;IAET,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mDAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;QACX,WAAW;IACf;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;AAEJ","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-text-subtle, color-purple from colors;\n\n.card {\n    position: relative;\n\n    flex: 1 0 45%;\n    min-width: 400px;\n    max-width: 600px;\n\n    border-radius: 5px;\n    background-color: white;\n    overflow: hidden;\n}\n\n.skeleton.card {\n    background: #e2e2e2;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.cover {\n    width: 100%;\n    height: 100px;\n    object-fit: cover;\n}\n\n.skeleton .cover {\n    background: #ececec;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n\n.header {\n    position: absolute;\n    top: 50px;\n\n    width: 100%;\n\n    padding: 16px;\n    box-sizing: border-box;\n}\n\n.header, .name {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.skeleton .society,\n.skeleton .owner,\n.skeleton .number {\n    width: 150px;\n    height: 18px;\n    background: #d3d3d3;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 4px;\n    margin-left: 4px;\n}\n\n.skeleton .number {\n    margin-top: 16px;\n}\n\n.skeleton .logo {\n    background: #d3d3d3;\n    border: none;\n    color: transparent;\n    position: relative;\n    overflow: hidden;\n}\n\n.skeleton .society::before,\n.skeleton .owner::before,\n.skeleton .logo::before,\n.skeleton .number::before {\n    content: \"\";\n    position: absolute;\n    left: -50%;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(to right, #d3d3d3 25%, #bebebe 50%, #d3d3d3 100%);\n    animation-name: gradient-animation;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    filter: blur(5px);\n}\n\n.logo {\n    width: 86px;\n    height: 86px;\n    border-radius: 86px;\n    border: 4px solid white;\n    object-fit: cover;\n    background-color: white;\n}\n\n.logo.placeholder {\n    background: rgb(137,154,255);\n    background: linear-gradient(90deg, rgba(137,154,255,1) 0%, rgba(79,103,243,1) 35%, rgba(36,56,173,1) 100%);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.logo.placeholder span {\n    font-family: Raleway, sans-serif;\n    font-size: 48px;\n    font-weight: 700;\n    color: white;\n}\n\n.information {\n    margin-top: 40px;\n    padding: 16px;\n    box-sizing: border-box;\n\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.society {\n    margin: 0;\n    font-weight: 500;\n    font-family: 'Roboto', sans-serif;\n    font-size: 18px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 280px;\n}\n\n.owner {\n    margin: 0;\n\n    color: color-text-subtle;\n    font-size: 14px;\n}\n\n.data p {\n    text-align: center;\n}\n\n.number {\n    font-weight: 500;\n    font-size: 20px;\n    margin-bottom: 0;\n}\n\n.label {\n    margin-top: 0;\n    color: color-text-subtle;\n}\n\n@keyframes gradient-animation {\n    from {\n        left: -50%;\n    }\n    to {\n        left: 100%;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    .card {\n        min-width: unset;\n        flex: unset;\n        width: 100%;\n    }\n\n    .header {\n        position: unset;\n        padding: 4px;\n        flex-wrap: wrap;\n    }\n\n    .name {\n        align-items: center;\n    }\n\n    .information {\n        padding: 8px;\n        margin-top: 0;\n        flex-wrap: wrap;\n    }\n\n    .number {\n        margin: 0;\n    }\n\n    .discover {\n        margin: auto;\n        height: 32px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"card": `CGK8B10v_4Et9tRTb7NH`,
	"skeleton": `i1jlSb6W4uiEdLT4Ja7j`,
	"cover": `L6O9uTnCU2pcwnCEEuI1`,
	"header": `o7Dx6vJsMFlKKdsseF20`,
	"name": `ZlrMhFVq_sWIkeJJrMHQ`,
	"society": `VxNBIu60Z5waILMYO2VH`,
	"owner": `vK_4c5qrkf6pqhjgivoi`,
	"number": `umr7sVjAj7yU1HDP6RHb`,
	"logo": `sCQwJ4cb_8pY0EIFB35p`,
	"gradient-animation": `yavhYd9fgoIDUE1Q5PkP`,
	"placeholder": `aZy_s_t9E4GBr3FDi7q_`,
	"information": `NBHbpi45n1Nwwcy6ZEfV`,
	"data": `RfHayD1QUXv4tjglbBgc`,
	"label": `Xs4zFt2My04xAyPe38jc`,
	"discover": `jDzODhFDdOHqYR1Uw13g`
};
export default ___CSS_LOADER_EXPORT___;
